export default __webpack_public_path__ + "assets/images/icons/gitlab.6dd19c00.svg";